module.exports = __webpack_public_path__ + "static/media/map.7a30e90e.jpg";